import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { addCart, openCart } from "../redux/action";

import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useCurrency } from "../context/CurrencyContext";
import useCourses from "../hooks/useCourses";
import { toAnalyticsItem, trackEvent } from "../lib/analytics";

const Products = () => {
  const courses = useCourses();
  const [filter, setFilter] = useState(courses);
  const { formatPrice, currency } = useCurrency();

  const dispatch = useDispatch();

  const addProduct = (product) => {
    trackEvent("add_to_cart", {
      currency,
      value: Number(product.price || 0),
      items: [toAnalyticsItem(product, 1)],
    });
    dispatch(addCart(product));
    dispatch(openCart());
  };

  useEffect(() => {
    setFilter(courses);
  }, [courses]);

  const categories = useMemo(
    () => ["Todos", ...new Set(courses.map((item) => item.category))],
    [courses]
  );

  const filterProduct = (cat) => {
    if (cat === "Todos") {
      setFilter(courses);
      return;
    }
    const updatedList = courses.filter((item) => item.category === cat);
    setFilter(updatedList);
  };

  const ShowProducts = () => {
    return (
      <>
        <div className="buttons text-center py-5" data-aos="fade-up">
          {categories.map((cat) => (
            <button
              key={cat}
              className="btn btn-outline-dark btn-sm m-2"
              onClick={() => filterProduct(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {filter.map((product, index) => {
          const delay = (index % 3) * 120;
          const hasDiscount =
            product.originalPrice && product.originalPrice > product.price;
          return (
            <div
              id={product.id}
              key={product.id}
              className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4"
              data-aos="fade-up"
              data-aos-delay={delay}
            >
              <div className="card h-100 catalog-card-minimal" key={product.id}>
                <img
                  className="card-img-top p-3 course-card-img"
                  src={product.image}
                  alt={product.title}
                />
                <div className="card-body catalog-content">
                  <h5 className="card-title catalog-title-min">{product.title}</h5>
                  <p className="card-text catalog-description-min">
                    {product.shortDescription}
                  </p>
                  <div className="catalog-divider" />
                </div>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <div className="course-price-box course-price-box-left">
                      <span className="course-price-current">
                        {formatPrice(product.price)}
                      </span>
                      {hasDiscount ? (
                        <span className="course-price-original">
                          {formatPrice(product.originalPrice)}
                        </span>
                      ) : null}
                    </div>
                  </li>
                </ul>
                <div className="card-body course-actions catalog-actions-min">
                  <Link
                    to={"/product/" + product.slug}
                    className="btn course-action-btn course-action-secondary"
                    aria-label="Ver temario"
                    title="Ver temario"
                  >
                    <i className="fa fa-eye me-2" aria-hidden="true"></i>
                    Ver temario
                  </Link>
                  <button
                    className="btn course-action-btn course-action-primary"
                    onClick={() => {
                      toast.success("Agregado al carrito");
                      addProduct(product);
                    }}
                    aria-label="Agregar al carrito"
                    title="Agregar al carrito"
                  >
                    <i className="fa fa-shopping-cart me-2" aria-hidden="true"></i>
                    Comprar
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="container my-3 py-3">
        <div className="row">
          <div className="col-12" data-aos="fade-up">
            <h2 className="display-5 text-center">Cursos y Paquetes</h2>
            <hr />
          </div>
        </div>
        <div className="row justify-content-center">
          <ShowProducts />
        </div>
      </div>
    </>
  );
};

export default Products;
